/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Dashboard Labels Component
 */

// Dependencies
import PropTypes from 'prop-types';

const DashboardLabel = ({ label, value, color, horizontal }) => {
  const showLabel = value ? (
    <span>
      <strong>{value}%</strong> {label}
    </span>
  ) : (
    label
  );
  return (
    <div
      className={`text-left text-baxterGray mb-4 mt-2 
      ${horizontal ? 'mr-5' : ''}`}>
      <span
        style={{
          verticalAlign: 'middle',
          marginRight: '5px',
          height: '8px',
          width: '8px',
          backgroundColor: color,
          borderRadius: '50%',
          display: 'inline-block'
        }}></span>
      <span style={{ fontSize: '12px' }}>{showLabel}</span>
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardLabel.propTypes = {
  label: PropTypes.any,
  color: PropTypes.any,
  value: PropTypes.any,
  horizontal: PropTypes.bool
};

export default DashboardLabel;
